import { useCallback, useState } from 'react';
import { SelectPaymentOperator } from '@/components/SelectPaymentOperator';
import { SelectPaymentMerchant } from '@/components/SelectPaymentMerchant';
import { SelectPaymentAccount } from '@/components/SelectPaymentAccount';
import { SelectLanguage } from '@/components/SelectLanguage';
import { SelectUserCountry } from '@/components/SelectUserCountry';
import { Drawer } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import * as Styled from './AppDrawer.styles';

export const AppDrawer = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <>
      <Styled.IconButton onClick={handleOpen} aria-label='settings'>
        <SettingsIcon />
      </Styled.IconButton>
      <Drawer
        anchor='right'
        open={open}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Styled.FilterWrapper>
          <SelectPaymentOperator />
          <SelectPaymentMerchant />
          <SelectPaymentAccount />
          <SelectLanguage />
          <SelectUserCountry />
        </Styled.FilterWrapper>
      </Drawer>
    </>
  );
};
